import { SourceType } from '../constants';

const DFS_KEYS = new Set(['prizepicks', 'underdog', 'pick6', 'betr_us_dfs']);
const EXCHANGE_KEYS = new Set(['novig', 'prophetx', 'betopenly', 'matchbook', 'betfair_ex_eu', 'betfair_ex_au']);
export const PREDICTION_KEYS = new Set(['kalshi', 'polymarket']);

export function getSourceTypeForBookmaker(bookmakerKey: string): SourceType {
  if (DFS_KEYS.has(bookmakerKey)) return 'dfs';
  if (EXCHANGE_KEYS.has(bookmakerKey)) return 'exchange';
  if (PREDICTION_KEYS.has(bookmakerKey)) return 'prediction_market';
  return 'sportsbook';
}

export const SOURCE_BADGE_COLORS: Record<SourceType, string> = {
  sportsbook: '',
  dfs: 'bg-purple-600',
  exchange: 'bg-amber-600',
  prediction_market: 'bg-emerald-600',
};

export const SOURCE_SHORT_LABELS: Record<SourceType, string> = {
  sportsbook: '',
  dfs: 'DFS',
  exchange: 'EXC',
  prediction_market: 'PM',
};
